import { render, staticRenderFns } from "./article-create.vue?vue&type=template&id=96fd4d78&"
import script from "./article-create.vue?vue&type=script&lang=js&"
export * from "./article-create.vue?vue&type=script&lang=js&"
import style0 from "./article-create.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willin/Documents/shiwangme/shiwangme_new_cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('96fd4d78', component.options)
    } else {
      api.reload('96fd4d78', component.options)
    }
    module.hot.accept("./article-create.vue?vue&type=template&id=96fd4d78&", function () {
      api.rerender('96fd4d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/views/material/article-create.vue"
export default component.exports